import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../../../common/dialog.service';
import { TabService } from '../../../../tabconfig/tab.service';
import { Tab } from '../../../../tabconfig/tab.model';
import { CoursesAddComponent } from '../courses-add/courses-add.component';
import { CourseService } from '../../../../api/Services/maintenance/course.service';
import { AuthService } from '../../../../system/auth.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { StudentCourseComponent } from '../../student-course/student-course.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';



@Component({
  selector: 'app-courses-list',
  templateUrl: './courses-list.component.html',
  styleUrls: ['./courses-list.component.css']
})
export class CoursesListComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  @Input() data;
  public displayedColumns: string[] = ['cou_vc_name', 'cou_in_duration', 'cou_vc_status', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('paginatorDatasource', {read: MatPaginator, static: true}) paginator: MatPaginator;
  parameters: any[];
  public form: FormGroup;
  
  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private courseServices: CourseService,
    private tabService: TabService,
    private authService : AuthService
  ) { }

  ngOnInit(): void {

    this.initForm();
    this.loadInitial();
  }

  public initForm() {
    this.form = this.formBuilder.group({
      cou_in_category: 0,
      cou_in_duration_type: 0 ,
      cou_in_status: 0
    });
  }

  public loadInitial() {
    this.parameters = this.authService.getParameters();
  }
  public LoadCourses(){

    
    this.courseServices.GetAll(this.form.getRawValue().cou_in_category,this.form.getRawValue().cou_in_duration_type,this.form.getRawValue().cou_in_status).subscribe(
      data => {
        console.log(data);
        
        if(data['sucess']){
          let result = data['data'];
          console.log(result);
          this.dataSource = new MatTableDataSource<any[]>(result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        else{
          this.toastr.warning('hubo un problema al tratar de obtener los datos', 'Advertencia');
        }
 
      }
    );
  }
 
  public nuevo(){
    this.tabService.addTab(new Tab(CoursesAddComponent, "Nuevo Curso", { parent: 'ListadoComponent' }));
  }
  
  public edit(element){
    
    this.tabService.addTab(new Tab(CoursesAddComponent, "Editar Curso", { parent: 'ListadoComponent', element: element }));
  }

  public delete(element){
    this.dialogService.openConfirmDialog('¿Seguro de eliminar este registro?')
    .afterClosed().subscribe(res => {
      if (res) {
        this.LoadingStart(); // Start blocking
        debugger;
        this.courseServices.Delete(element.cou_in_id).subscribe(
          data => {
            this.LoadingStop();
            if (data['sucess']) {
              let result = data['data'][0];
              this.LoadCourses();
              this.toastr.success(data['msg'], 'Correcto');
            }
            else {
              this.toastr.warning(data['msg'], 'Advertencia');
            }
          }
        );

      }
    });
  }
  public assign(element){
  //  this.tabService.removeTab(this.data.id - 1)
    this.tabService.addTab(new Tab(StudentCourseComponent, "Alumnos Matriculados", { parent: 'ListadoComponent', element: element }));
  }
  public buscar(){
    this.LoadCourses();
  }

  LoadingStart(){
    this.blockUI.start('Cargando...');
  }
  LoadingStop(){
    this.blockUI.stop();
  }
  setEstado(val:number,element){

    const title =   'Seguro de cambiar el estado?';
    const titleSuccess =  'Se actualizo el estado correctamente';
    this.dialogService.openConfirmDialog(title)
      .afterClosed().subscribe(res =>{
      if(res){
       /* this.form.setValue(element);
        this.form.controls['cou_in_status'].setValue(val);*/
        element.cou_in_status = val;
        this.courseServices.UpdateStatus(element).subscribe(
          data => {
            this.LoadCourses();
            this.toastr.success(titleSuccess, 'Correcto');
          }
        );
      }
    });

  }
}
